import { render, staticRenderFns } from "./WorkspaceFabric.vue?vue&type=template&id=18bab7fe&scoped=true&"
import script from "./WorkspaceFabric.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFabric.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceFabric.vue?vue&type=style&index=0&id=18bab7fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bab7fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18bab7fe')) {
      api.createRecord('18bab7fe', component.options)
    } else {
      api.reload('18bab7fe', component.options)
    }
    module.hot.accept("./WorkspaceFabric.vue?vue&type=template&id=18bab7fe&scoped=true&", function () {
      api.rerender('18bab7fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceFabric.vue"
export default component.exports